import React, { useState, useEffect, useCallback } from 'react';
import { useListener } from '~/emitter';

import { VerificationProvider } from './context';

import VerificationModal from './VerificationModal';
import VerificationBanner from './VerificationBanner';
import { useDomainVerificationQuery } from '~/theseus/hooks/queries';

const DomainVerification = () => {
  const { data: isVerified, isFetched } = useDomainVerificationQuery();
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = useCallback(() => {
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  // Since the AdTypePicker can also open up the DNSVerification modal, we need
  // to be able to listen and react to that event
  useListener('open-dns-modal', openModal);

  return (
    <VerificationProvider>
      { isFetched && !isVerified && <VerificationBanner onOpen={openModal} /> }
      <VerificationModal
        isOpen={modalOpen}
        onClose={closeModal}
      />
    </VerificationProvider>
  );
};

export default DomainVerification;
